import React from "react";
import styles from "./InvoicePreviewModal.module.scss";
import { Modal } from "antd";
import { previewTableConsts } from "./constants";
import TNButton from "../../reusable-components/TNButton";
import {
  ButtonShape,
  ButtonType,
  CommonButtonTexts,
} from "../../enums/ButtonAttributesEnums";
import FileViewer from "./FileViewer";
import { downloadUtil } from "../../utils/downloadUtil";
import ConditionalRender from "../../reusable-components/ConditionalRender";

export interface InvoicePreviewTemplateProps {
  isOpen: boolean;
  handleClose: () => void;
  url?: string;
  editAccess?: boolean;
}

const InvoicePreviewTemplate = ({
  isOpen,
  handleClose,
  url,
  editAccess,
}: InvoicePreviewTemplateProps) => {
  const { MODAL_WIDTH, MODAL_TITLE } = previewTableConsts;

  return (
    <Modal
      visible={isOpen}
      footer={null}
      className={styles.previewInvoiceModal}
      width={"846px"}
      title={
        <div className={styles.modalTitleContainer}>
          {MODAL_TITLE}
          <TNButton
            type={ButtonType.DEFAULT}
            shape={ButtonShape.DEFAULT}
            text={CommonButtonTexts.DOWNLOAD}
            className={styles.modalTitleButton}
            onClick={() => downloadUtil(url)}
            disabled={!editAccess}
          />
        </div>
      }
      onCancel={() => handleClose?.()}
      destroyOnClose
    >
      <FileViewer url={url} />
    </Modal>
  );
};

export default InvoicePreviewTemplate;
